import { useEffect, useState } from 'react';
import { getNewsletterPlan, setNewsletterPlan } from '../../api/newsletterApi';

export default function NewsletterWeek() {
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getNewsletterPlan().then((res) => {
      if (res?.ok) setPlan(res);
      else setError('Newsletter plan is not available yet.');
    }).catch(() => setError('Newsletter plan is not available yet.'));
  }, []);

  const choose = async (writeThisWeek) => {
    const res = await setNewsletterPlan({ writeThisWeek });
    if (res?.ok) setPlan((current) => ({ ...current, ...res }));
  };

  if (error) return <p className="newsletter-week-note">{error}</p>;
  if (!plan) return null;

  return (
    <div className="newsletter-week">
      <div>
        <strong>This week ({plan.week})</strong>
        <p>{plan.writeThisWeek ? 'You are writing the note. Monday’s run will not draft one.' : 'Monday’s run will ask the research service for a draft and email it to you.'}</p>
      </div>
      <button type="button" onClick={() => choose(!plan.writeThisWeek)}>
        {plan.writeThisWeek ? 'Use the research draft' : 'I will write this week'}
      </button>
    </div>
  );
}
